import createResource from './createResource';
import { BillingCopay } from './types';

const billingCopaysResource = createResource<BillingCopay>({
  key: 'billingCopays',
  url: '/billingcopays',
  hasFetchBulkSupport: true,
});

export default billingCopaysResource;
